import { apiClient } from './api-client';

export interface TimelineEntry {
  id: string;
  eventName: string;
  actorId: string | null;
  actorName: string | null;
  actorRoleName?: string | null;
  occurredAt: string;
}

export interface EquipmentTimeline {
  items: TimelineEntry[];
  total: number;
}

export interface InspectionTimeline {
  items: TimelineEntry[];
  total: number;
}

export const auditLogService = {
  getEquipmentTimeline(equipmentId: string): Promise<EquipmentTimeline> {
    return apiClient
      .get<EquipmentTimeline>(`/audit-log/entity/equipment/${equipmentId}`)
      .then((r) => r.data);
  },

  getInspectionTimeline(inspectionId: string): Promise<InspectionTimeline> {
    return apiClient
      .get<InspectionTimeline>(`/audit-log/entity/inspection/${inspectionId}`)
      .then((r) => r.data);
  },
};
